import { useCatalogCategories } from "@/hooks/use-desk-migration";

/** Catalog item id → name for the tenant's whole catalog. */
export function useCatalogItemNames(tenantId: string) {
  const { data, isLoading } = useCatalogCategories(tenantId);
  const names = new Map<string, string>();
  for (const category of data?.categories ?? []) {
    for (const item of category.items ?? []) names.set(item.id, item.name);
  }
  return { names, isLoading };
}
